import PropTypes from 'prop-types';
import { useEffect } from 'react';
import {
  BoldedText,
  DateTimeText,
  NormalText,
  TimeWrapper,
  TrackingRecordRow,
} from '@/modules/track-and-trace/track-record-row/track-record-row.styles';
import { displayTimeStringDate, displayTimeWithAmPm } from '@/utilities/reusable-functions/display-util';

const TrackRecordRow = ({ trackingRecord, noHeader = false, noContent = false }) => {
  useEffect(() => {}, [trackingRecord]);

  return (
    <TrackingRecordRow noHeader={noHeader}>
      {!noHeader && <BoldedText>{trackingRecord.statusType}</BoldedText>}
      {!noContent && (
        <>
          <NormalText>{trackingRecord.description}</NormalText>
          <DateTimeText>
            {displayTimeStringDate(new Date(trackingRecord.createDateTime))}
            <TimeWrapper>{displayTimeWithAmPm(new Date(trackingRecord.createDateTime))}</TimeWrapper>
          </DateTimeText>
        </>
      )}
    </TrackingRecordRow>
  );
};

TrackRecordRow.propTypes = {
  trackingRecord: PropTypes.object.isRequired,
  noHeader: PropTypes.bool,
  noContent: PropTypes.bool,
};

export default TrackRecordRow;
